import React from 'react';
import queryString from 'query-string';
import Lightbox from 'react-images';
import { Field,reduxForm,formValueSelector,change } from 'redux-form';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import renderCheckbox from '../../components/MaterialUi/renderCheckbox';
import * as actions from '../../redux/imgCate/actions';

import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ListOfCheckboxes from './ListOfCheckboxes'
import validate from './validate'

const closeLightbox=(props)=>{
    props.closeLightBox();
}

const imageBoxOnClick=(props)=>{
    props.openLightBox();
}

const renderSubmitButton = (props,imageNotLoad,hasNone,pristine,submitting) => {
    let { readyToSubmit } = props;
    
    if (imageNotLoad || hasNone || (readyToSubmit && readyToSubmit == true)){
        return (
            <div className="d-flex flex-row"> 
                <div className="p-2">
                    <button className="btn btn-primary btn-lg" type="submit" disabled={submitting}>
                    Submit Your Answer
                    </button>
                </div>
            </div>
        );
    }
}  

const encodeImageUrl=(imgUrl,imgId)=>{
    let arrImgUrl=imgUrl.split('/');
    arrImgUrl.splice(arrImgUrl.length - 1, 1);//Remove last element
    let newImgUrl=arrImgUrl.join('/');
    let encodeImgId=imgId;
    encodeImgId=decodeURIComponent(imgId);
    encodeImgId=encodeURIComponent(imgId);

    newImgUrl=`${newImgUrl}/${encodeImgId}`;
    return newImgUrl;
}

export class ImageCategorisation extends React.Component {
    
    componentWillMount(){
        const { location } = this.props;
        const query = queryString.parse(location.search);
        const { jwt, taskAcceptedInfoId } = query;
        
        this.props.getTaskConfig(jwt,taskAcceptedInfoId);
    }
    
    componentDidUpdate(){
        const { imgCate } = this.props;
        if (imgCate.updateImgCateQuestions){
            this.props.updateImgCateQuestions(imgCate.task);
        }
    }

    noOfAboveOnChange(e) {
        let imgCateForm={};
        imgCateForm.hasNone=e.target.checked;
        this.props.updateAnswer(imgCateForm);
    }
    
    imageNotLoadOnChange(e){
        let imgCateForm={};
        imgCateForm.imageNotLoad=e.target.checked;
        this.props.updateAnswer(imgCateForm);
    }
    
    render(){
        const { location,handleSubmit,imageNotLoad,hasNone,pristine,submitting,initialValues,imgCate } = this.props;
        const query = queryString.parse(location.search);
        const taskTitle=imgCate.task?imgCate.task.task_name: 'Image Categorisation';
        
        if (imgCate.submitted) {
            return <Redirect to="/imgCateThankYou"/>;
        }
    
        if (!query.jwt || !query.imgUrl || !query.taskAcceptedInfoId) {
            return (
                <div className="container">
                   <ContainerRowSpace /> 
                   <ContainerRowTitle  title={taskTitle} />
                   <ContainerRowError  errorMsg={'Missing parameters!'} />
                </div>
            )
        }
    
        const imgUrl=encodeImageUrl(query.imgUrl,query.imgId);

        return (
            <div className="container">
                <ContainerRowSpace /> 
                <ContainerRowTitle  title={taskTitle} />
                
                <div className='row'>
                    <div className='col-sm'>
                        <div className="ImageBox">
                            <img src={imgUrl} style={{width: '100%',height: 'auto'}}  onClick={()=>imageBoxOnClick(this.props)}  />
                        </div>
                        <Lightbox
                            images={[{ src: imgUrl }]}
                            onClose={()=>closeLightbox(this.props)}
                            isOpen={imgCate.openLightbox}
                        />
                    </div>
                </div>
                
                <ContainerRowSpace /> 
                <form onSubmit={handleSubmit} >
                
                <div className='row'>    
                    <div className='col-sm'>
                        {imgCate.imgCateQuestions.map((item)=>{
                            return (
                                <div key={item.order} >
                                    <h3 className="display-7">{item.question}</h3>  
                                    <ListOfCheckboxes {...this.props} 
                                       key={item.order} answers={item.answers}
                                       changeFieldValue={this.props.changeFieldValue} />
                                </div>    
                            )
                        })}
                   </div>
                </div>
               
                <div className='row'>
                    <div className='col-sm'>
                        <Field name="hasNone" 
                            component={renderCheckbox} 
                            label="None of Above" 
                            onChange={this.noOfAboveOnChange.bind(this)} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <Field name="imageNotLoad" 
                            component={renderCheckbox} 
                            label="Image does not load" 
                            onChange={this.imageNotLoadOnChange.bind(this)} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                       {renderSubmitButton(this.props,imageNotLoad,hasNone,pristine,submitting)}
                    </div>
                </div>
                </form>
            </div>
        )
    }
}

const submit = (values, dispatch, props) => {
    const { imgCate } = props;
    const query = queryString.parse(props.location.search);
    const jwt = query.jwt;
    const taskAcceptedInfoId = query.taskAcceptedInfoId;

    props.submitResult(jwt,values,taskAcceptedInfoId,imgCate);
}

const form = 'imgCateForm'
const imgCateReduxForm = reduxForm({
    form: form, // a unique identifier for this form
    validate,
    enableReinitialize: true,
    onSubmit: submit
})(ImageCategorisation) 

const selector = formValueSelector(form)

const mapStateToProps = (state, ownProps) => {
    return {
        initialValues: state.imgCate.imgCateForm,
        imageNotLoad: selector(state, 'imageNotLoad'),
        hasNone: selector(state, 'hasNone'),
        imgCate: state.imgCate,
        readyToSubmit: selector(state, 'readyToSubmit')
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      getTaskConfig: (jwt,taskAcceptedInfoId) => {
        dispatch(actions.getTaskConfig(jwt,taskAcceptedInfoId))  
      }, 
      updateImgCateQuestions: (task) => {
        dispatch(actions.updateImgCateQuestions(task))  
      },  
      selectedImageCate: () => {
         dispatch(actions.selectedImageCate())  
      },
      deselectedImageCate: () => {
        dispatch(actions.deselectedImageCate())  
      },
      updateAnswer: (imgCateForm) => {
        dispatch(actions.updateAnswer(imgCateForm))  
      },
      openLightBox: () => {
        dispatch(actions.openLightBox())  
      },
      closeLightBox: () => {
        dispatch(actions.closeLightBox())  
      },
      submitResult: (jwt,imgCateForm,taskAcceptedInfoId,imgCate) => {
        dispatch(actions.submitResult(jwt,imgCateForm,taskAcceptedInfoId,imgCate))  
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(imgCateReduxForm)


// WEBPACK FOOTER //
// ./src/views/ImageCategorisation/ImageCategorisation.js